(() => {

    const SELECTOR = "[data-swiper-component]";
    const STATE_KEY = "swiperGlobal";

    const CDN = {
        css: "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
        js: "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js",
    };

    function hasAnySwiperComponents(root = document) {
        return Boolean(root.querySelector(SELECTOR));
    }

    function ensureStylesheet(href) {
        if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) return;

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
    }

    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) {
                if (existing.dataset.loaded === "true") return resolve();
                existing.addEventListener("load", () => resolve(), { once: true });
                existing.addEventListener("error", () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
                return;
            }

            const s = document.createElement("script");
            s.src = src;
            s.async = true;
            s.dataset.loaded = "false";
            s.addEventListener("load", () => {
                s.dataset.loaded = "true";
                resolve();
            }, { once: true });
            s.addEventListener("error", () => reject(new Error(`Failed to load script: ${src}`)), { once: true });

            document.head.appendChild(s);
        });
    }

    async function ensureSwiperLoaded() {
        const state = window[STATE_KEY] || (window[STATE_KEY] = {});
        if (state.loadingPromise) return state.loadingPromise;

        state.loadingPromise = (async () => {
            ensureStylesheet(CDN.css);
            await loadScript(CDN.js);

            if (!window.Swiper) {
                throw new Error("Swiper loaded but window.Swiper is not available.");
            }
        })();

        return state.loadingPromise;
    }

    async function ensureInitializerLoaded() {
        const src = window.__SWIPER_GLOBAL_INIT_SRC;
        if (!src) throw new Error("Missing window.__SWIPER_GLOBAL_INIT_SRC");

        await loadScript(src);

        if (!window.SwiperGlobal || typeof window.SwiperGlobal.initAll !== "function") {
            throw new Error("swiper-global-init.js loaded but window.SwiperGlobal.initAll is not available.");
        }
    }

    async function initIfNeeded(root = document) {
        if (!hasAnySwiperComponents(root)) return;

        await ensureSwiperLoaded();
        await ensureInitializerLoaded();

        window.SwiperGlobal.initAll(root);
    }

    window.SwiperBootstrap = {
        initIfNeeded,
    };

    document.addEventListener("DOMContentLoaded", () => {
        initIfNeeded(document).catch((err) => console.error("[Swiper] init failed:", err));
    });

    document.addEventListener("shopify:section:load", (e) => {
        const root = e?.target || document;
        initIfNeeded(root).catch((err) => console.error("[Swiper] section init failed:", err));
    });

    const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (!(node instanceof HTMLElement)) continue;
                if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) {
                    initIfNeeded(node).catch((err) => console.error("[Swiper] mutation init failed:", err));
                    return;
                }
            }
        }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
})();
